import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as Actions from "../actions/Actions.js";
import { useNavigate } from "react-router-dom";
import AuthenticationHOC from "../components/AuthenticationHOC.js";
import Helper from "../functions/Helper.js";
import Button from "react-bootstrap/Button";
import { Link } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import UserReviewPopup from "../components/UserReviewPopup.js";
import CustomPagination from "../components/CustomPagination";
import queryString from "query-string";
import { useLocation } from "react-router-dom";

function Account(props) {
  const navigate = useNavigate();
  const { search } = useLocation();
  let pageIndex = Number(queryString.parse(search)?.pg ?? 1);

  useEffect(() => {
    fetch(__server__ + "/API/user/details", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + props.jwt,
      },
    })
      .then((response) => {
        if (response.status === 401) {
          navigate("/shoe-reviews/login", {
            state: { nextPath: "/shoe-reviews/account" },
            replace: true,
          });
        } else {
          return response.json();
        }
      })
      .then((data) => {
        setDetails(data);
      })
      .catch((error) => {});
  }, []);

  useEffect(() => {
    fetch(
      __server__ + "/API/user/user_reviews?offset=" + (pageIndex - 1) * 10,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + props.jwt,
        },
      }
    )
      .then((response) => response.json())
      .then((data) => {
        setReviews(data);
      });
  }, [pageIndex]);

  const [details, setDetails] = useState(false);
  const [reviews, setReviews] = useState([]);
  const [showReviewPopup, setShowReviewPopup] = useState(false);
  const [currentRewiew, setCurrentReview] = useState(false);

  let paginationArray = [];
  for (let i = 1; i <= Math.ceil((details.reviews ?? 0) / 10); i++) {
    paginationArray.push(i);
  }

  return (
    <div style={{ minHeight: "100vh" }}>
      <Modal
        show={showReviewPopup}
        onHide={() => {
          setShowReviewPopup(false);
        }}
      >
        <UserReviewPopup review={currentRewiew} />
      </Modal>
      {details && (
        <>
          <h3 style={{ marginBottom: 30 }}>Account Details</h3>
          <div style={{ fontSize: 16 }}>
            <div
              style={{
                display: "inline-block",
                fontWeight: 600,
                marginBottom: 10,
                marginRight: 10,
                width: 100,
              }}
            >
              Name:
            </div>
            {details.name}
          </div>
          <div style={{ fontSize: 16 }}>
            <div
              style={{
                display: "inline-block",
                fontWeight: 600,
                marginBottom: 10,
                marginRight: 10,
                width: 100,
              }}
            >
              Email:
            </div>
            {details.email}
          </div>
          {/*
        <div style={{marginBottom:30,fontWeight:600}}>
          Logins:
        </div>
          {details.facebook_login!== null &&
            <span style={{fontSize:16,marginRight:10,padding:"20px 20px",border:0,backgroundColor:"#4267B2",color:"#fff",fontWeight:600}}>
              <i style={{marginRight:10}} className="fab fa-facebook-f"/>Facebook
            </span>
          }

          {details.facebook_login!== null &&
            <span style={{fontSize:16,padding:"20px 20px",border:0,backgroundColor:"#4285f4",color:"#fff",fontWeight:600}}>
              <i style={{marginRight:10}} className="fab fa-facebook-f"/>Google
            </span>
          }*/}

          <h3 style={{ marginTop: 50 }}>Your Reviews</h3>

          <div style={{ overflowX: "auto" }}>
            <table style={{ borderSpacing: "0px 10px", marginBottom: 5 }}>
              <tbody>
                {reviews.map((review) => (
                  <tr
                    key={review.user_review_id}
                    style={{ backgroundColor: "#fafafa" }}
                  >
                    <td
                      style={{
                        width: 60,
                        verticalAlign: "middle",
                        alignItems: "center",
                        padding: "8px 15px",
                        fontWeight: "600",
                        color: "white",
                        backgroundColor: Helper.get_color(review.rating, "bg"),
                      }}
                    >
                      {review.rating}
                    </td>
                    <td
                      style={{
                        minWidth: 180,
                        alignItems: "center",
                        verticalAlign: "middle",
                        padding: "8px 15px",
                        fontWeight: 600,
                        fontSize: 16,
                      }}
                    >
                      {review.shoe_name}
                    </td>
                    {[
                      "traction",
                      "cushion",
                      "materials",
                      "support",
                      "fit",
                      "durability",
                    ].map((category) => (
                      <td
                        key={category}
                        style={{
                          backgroundColor: "#fafafa",
                          width: 70,
                          flexDirection: "column",
                          alignItems: "center",
                          justifyContent: "center",
                          padding: 10,
                        }}
                      >
                        <div
                          style={{
                            fontSize: 12,
                            lineHeight: "12px",
                            marginBottom: 6,
                          }}
                        >
                          {Helper.capitalize(category)}
                        </div>
                        <div
                          style={{
                            fontWeight: 600,
                            fontSize: 16,
                            lineHeight: "16px",
                            color: Helper.get_color(review[category], "text"),
                          }}
                        >
                          {review[category]}
                        </div>
                      </td>
                    ))}

                    <td
                      style={{
                        backgroundColor: "#fafafa",
                        width: 70,
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        padding: 10,
                      }}
                    >
                      <div
                        style={{
                          fontSize: 12,
                          lineHeight: "12px",
                          marginBottom: 6,
                        }}
                      >
                        Outdoor:
                      </div>
                      <div
                        style={{
                          fontWeight: 600,
                          fontSize: 13,
                          lineHeight: "13px",
                          color: Helper.get_color(review.outdoor, "outdoor"),
                        }}
                      >
                        {Helper.getOutdoorDescription(review.outdoor)}
                      </div>
                    </td>

                    <td
                      style={{
                        fontSize: 14,
                        backgroundColor: "#fafafa",
                        width: 100,
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        padding: 10,
                      }}
                    >
                      <div
                        style={{
                          fontSize: 12,
                          lineHeight: "12px",
                          marginBottom: 6,
                        }}
                      >
                        Date:
                      </div>
                      <div
                        style={{
                          fontWeight: 600,
                          fontSize: 13,
                          lineHeight: "13px",
                        }}
                      >
                        {Helper.getDateFromMysql(
                          review.date
                        ).toLocaleDateString()}
                      </div>
                    </td>
                    <td
                      style={{
                        verticalAlign: "middle",
                        whiteSpace: "nowrap",
                        textAlign: "right",
                      }}
                    >
                      <Button
                        onClick={() => {
                          setShowReviewPopup(true);
                          setCurrentReview(review);
                        }}
                        style={{ fontSize: 13 }}
                        size="sm"
                        variant="outline-dark"
                      >
                        Show
                      </Button>
                      <Link
                        to={
                          "/shoe-reviews/rating?user_review_id=" +
                          review.user_review_id +
                          "&shoe_id=" +
                          review.shoe_id
                        }
                      >
                        <Button
                          style={{ fontSize: 13, marginLeft: 10 }}
                          size="sm"
                          variant="outline-dark"
                        >
                          Edit
                        </Button>
                      </Link>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}
      <div style={{ marginTop: 20 }}>
        <CustomPagination
          getPaginationLink={(x) => ({
            pathname: "/shoe-reviews/account/",
            search: "pg=" + x,
          })}
          pages={paginationArray}
          pageIndex={pageIndex}
        />
      </div>
    </div>
  );
}

export default connect(
  (state) => ({ ...state.persistData }),
  (dispatch) => ({
    actions: bindActionCreators(Actions, dispatch),
  })
)(AuthenticationHOC(Account));
